import { Box } from '@mui/material';
import React from 'react';
import AppCard from '../../components/AppCard';
import AppCardSkeleton from '../../components/atoms/AppCardSkeleton';
import type { Product } from '../../redux/slices/productList';
import { homeGridSx, useHomeGridLayout } from './homeGridLayout';
import { ItemWrapper, ProductGrid, ScrollableContainer } from './Home.styles';

type HomeProductGridProps = {
    loading: boolean;
    items: Product[];
};

/** One page of the feed. Pages are a fixed size, so the grid renders every card directly (no virtual list). */
const HomeProductGrid = React.memo(function HomeProductGrid({ loading, items }: HomeProductGridProps) {
    const layout = useHomeGridLayout();

    if (loading) {
        return (
            <ScrollableContainer aria-busy="true">
                <ProductGrid>
                    {Array.from({ length: layout.columnCount * 2 }, (_, i) => (
                        <ItemWrapper key={`skel-${i}`}>
                            <AppCardSkeleton />
                        </ItemWrapper>
                    ))}
                </ProductGrid>
            </ScrollableContainer>
        );
    }

    if (!items.length) {
        return null;
    }

    return (
        <ScrollableContainer>
            <Box sx={homeGridSx(layout)}>
                {items.map((item, index) => (
                    <ItemWrapper key={item.id ?? `item-${index}`}>
                        <AppCard type="normal" details={item} />
                    </ItemWrapper>
                ))}
            </Box>
        </ScrollableContainer>
    );
});

export default HomeProductGrid;
